import React, { FunctionComponent } from 'react';

import { Field } from 'formik';
import { SelectFieldType } from '../../types';
import classNames from 'classnames';

const SelectField: FunctionComponent<SelectFieldType> = ({ formikProps, label, name, required, disabled, children }) => {
  return (
    <div>
      <label
        htmlFor={`select-field-${name}`}
        className={classNames('form-label', formikProps.touched?.[name] && formikProps.errors?.[name] && 'text-danger')}
      >
        {label}
        {required && <span className="text-danger"> *</span>}
      </label>
      <Field
        as="select"
        name={name}
        id={`select-field-${name}`}
        disabled={disabled || formikProps.isSubmitting}
        className={classNames('form-select', formikProps.touched?.[name] && formikProps.errors?.[name] && 'is-invalid')}
      >
        {children}
      </Field>
      {formikProps.touched?.[name] && formikProps.errors?.[name] && (
        <div className="invalid-feedback">
          <>{formikProps.errors[name]}</>
        </div>
      )}
    </div>
  );
};

export default SelectField;
